import React, { Component } from 'react';
import '../../content/css/ContractReviewer.css';
import AuthService from "../../services/auth.service";
import HowItWorks from '../Misc/HowItWorks';
import { history } from '../../helpers';

export default class Home extends Component {
    constructor(props) {
        super(props);
        this.authService = new AuthService();
    }

    gotoUpload() {
        history.push("/upload");
    }

    render() {
        let isGuest = this.authService.isGuest();
        let showHowItWorks = isGuest && false;
        return (
            <div>
                {showHowItWorks &&
                    <HowItWorks />
                }
                {!showHowItWorks && this.gotoUpload()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/Home.js